import { Route, redirect } from "@tanstack/react-router";
import { rootRoute } from "../root";

export const projectsAnimalWelfareRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/projects/animal-welfare",
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
